import { useState, useEffect, useContext } from 'react'
import { useApolloClient } from "@apollo/client";
import { useMutation } from "@apollo/client";
import { Box, Flex, Text, Button, IconButton, useDisclosure, useToast } from "@chakra-ui/react";
import { CloseIcon, CheckIcon } from "@chakra-ui/icons";
import { v4 as uuidv4 } from 'uuid';
import {
    UPDATE_PUBLISHER,
    BUILD_EDSHOP,
    CREATE_ABOUT_SEO_WITH_AI
} from "../../graphql/mutations";
import {
    USER_PUBLISHER_ROLE
} from "../../graphql/queries";
import { getCookie } from '../../utils/cookie';
import { PublisherAndUserContext } from '../../contexts/PublisherAndUserContext';
import { useStore } from "../../Store";
import { uploadDALLEWithSasToken } from '../../utils/helper';
import { defaultPPTTheme } from '../../config';

export const useStoreSetting = () => {
    const { user, publisher, updatePublisherState } = useContext(PublisherAndUserContext);
    const { building, updateStates, storeSetting } = useStore((state) => state);
    // const [storeSetting, setStoreSetting] = useState({});
    const [imageUrl, setImageUrl] = useState("")
    const [videoUrl, setVideoUrl] = useState("")
    const [pptUrl, setPptUrl] = useState("")
    const [loading, setLoading] = useState({isLoading: false, loadingMessage: ""});
    const [buildStore, setBuildStore] = useState(false);
    const [pptTheme, setPptTheme] = useState(false);
    const [prompt, setPrompt] = useState("");
    const [isImageLoading, setIsImageLoading] = useState(false);
    const toast = useToast();
    const apolloClient = useApolloClient();
    const postUrl = process.env.REACT_APP_ADMIN_APP_GRAPHQL_ENDPOINT;

    const {
        isOpen,
        onOpen,
        onClose
    } = useDisclosure();
    const {
        isOpen: videoIsOpen,
        onOpen: videoOnOpen,
        onClose: videoOnClose
    } = useDisclosure();
    const {
        isOpen: pptIsOpen,
        onOpen: pptOnOpen,
        onClose: pptOnClose
    } = useDisclosure();


    const selectMedia = (type, url, media) => {
        if (type === "images") {
            setImageUrl(url)
        } else if(type === "videos") {
            setVideoUrl(url)
        } else {
            setPptUrl(media.url)
        }
    }

    // const pollingToCheckAvailabilityOfWebsite = (url, interval = 10000) => {
    //     return new Promise((resolve, reject) => {
    //       const check = async () => {
    //         try {
    //           const res = await fetch(url, { method: 'GET' });
    //           if (res.ok) {
    //             toast({
    //               position: "top",
    //               description: `Store is available.`,
    //               status: "success",
    //               duration: 9000,
    //               isClosable: true,
    //             });
    //             updateStates({ building: false });
    //             updatePublisher({
    //                 variables: {
    //                     where: {
    //                         id: publisher.id,
    //                     },
    //                     data: {
    //                         otherInfo: {
    //                             ...storeSetting.otherInfo,
    //                             isBuildComplete: true
    //                         }
    //                     },
    //                 },
    //             });
    //             resolve(true);
    //           } else {
    //             setTimeout(check, interval);
    //           }
    //         } catch (err) {
    //           setTimeout(check, interval); // keep retrying
    //         }
    //       };
    //       check();
    //     });
    //   };

    const checkWebsiteAvailability = async (url) => {
        try {
            const response = await fetch(url, {
              mode: 'no-cors',
              method: 'HEAD',
              cache: 'no-cache',
              signal: AbortSignal.timeout(5000),
            });
        
            // Important: Check response.ok *before* trying to access other properties
            if (!response.ok) {
              // Handle HTTP errors (400, 500, etc.)
              console.error(`HTTP error! status: ${response.status}`);
              return false; // Or throw an error, depending on your needs
            }
        
            return true; // Website is available (200-299 status)
          } catch (error) {
            // Handle network errors, timeouts, and other exceptions
            console.error("Error checking website:", error);
            return false; // Website is unavailable
          }
      };

    const polling = async (id, interval = 10000) => {
        return new Promise((resolve, reject) => {
            function checkStatus() {
                fetch(postUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": getCookie("dyn_session"),
                    },
                    body: JSON.stringify({
                        query: `
                        query EdshopifyBuildStorePipelineStatus($where: EdshopifyBuildStoreWhereInput!, $data: EdshopifyBuildStorePipelineStatusInput!) {
                              edshopifyBuildStorePipelineStatus(where: $where, data: $data) {
                                id
                                state
                          }
                        }
                      `,
                        variables: {
                            where: {
                                id: publisher?.id,
                            },
                            data: {
                                runId: id
                            }
                        },
                    }),
                }).then((res) => res.json())
                    .then((data) => {
                        if (data.data.edshopifyBuildStorePipelineStatus.state === "completed") {
                            // toast({
                            //     position: "top",
                            //     description: `Store is available.`,
                            //     status: "success",
                            //     duration: 9000,
                            //     isClosable: true,
                            //   });
                              updateStates({ building: false });
                              if(!storeSetting?.otherInfo?.isBuildComplete) {
                                  updatePublisher({
                                      variables: {
                                          where: {
                                              id: publisher.id,
                                          },
                                          data: {
                                              otherInfo: {
                                                  ...storeSetting.otherInfo,
                                                  isBuildComplete: true
                                              }
                                          },
                                      },
                                  });
                              }
                            resolve()
                        } else {
                            setTimeout(() => checkStatus(), interval);
                        }
                    }).catch(reject)
            }
            checkStatus()
        })
    }

    const [buildEdshop] = useMutation(BUILD_EDSHOP, {
        onCompleted: (data) => {
            polling(data.edshopifyBuildStore?.id)
        },
        onError: () => {
        },
    });

    const [updatePublisher] = useMutation(UPDATE_PUBLISHER, {
        update: (cache, { data }, { variables }) => {
            cache.writeQuery({
                query: USER_PUBLISHER_ROLE,
                variables: {
                    variables: {
                        where: {
                            ...(user.email
                                ? { email: user.email }
                                : { phone: user.phone }),
                        },
                    },
                },
                data: {
                    ...data.updatePublisher,
                    otherInfo: {
                        ...data.updatePublisher.otherInfo,
                        isStoreSettingComplete: data.updatePublisher?.otherInfo?.isStoreSettingComplete,
                    },
                },
            });
            updatePublisherState({
                ...publisher,
                otherInfo: {
                    ...data.updatePublisher.otherInfo,
                    isStoreSettingComplete: data.updatePublisher?.otherInfo?.isStoreSettingComplete,
                },
            })
            setLoading({isLoading: false, loadingMessage: ""})
            if (!data.updatePublisher.otherInfo?.isBuildComplete || buildStore) {
                updateStates({ building: true })
                buildEdshop({
                    variables: {
                        where: {
                            id: publisher?.id
                        }
                    }
                })
            }
            toast({
                position: "top-right",
                description: `Store settings updated!`,
                status: "success",
                duration: 2000,
                isClosable: true,
            });
        },
        onError: () => {
            setLoading({isLoading: false, loadingMessage: ""})
            toast({
                position: "top-right",
                description: `Failed to update store settings`,
                status: "error",
                duration: 2000,
                isClosable: true,
            });
        },
    });

    const [createAboutAndSeo] = useMutation(
        CREATE_ABOUT_SEO_WITH_AI,
        {
            onCompleted: async (data) => {
                const content = data?.edshopifyCreateStoreAboutAndSEOWithAI
                const uuid = uuidv4()
                const sasUrl = await uploadDALLEWithSasToken(publisher?.id, "images", content.logoImage, uuid, uuid)
                if (!sasUrl) {
                    setIsImageLoading(false)
                    toast({
                        position: "top-right",
                        title: "Error uploading logo.",
                        status: "error",
                        duration: 2000,
                        isClosable: true,
                    });
                }
                if (content.about !== "" && content.seoTitle !== "" && content.seoDescription !== "") {
                    setImageUrl(sasUrl ? `${sasUrl?.split("?")[0]}` : publisher?.logoPath)
                    setIsImageLoading(false)
                    setPrompt("")
                    setLoading({isLoading: false, loadingMessage: ""})
                    updateStates({ storeSetting: {
                        ...storeSetting,
                        about: content.about,
                        logoPath: sasUrl ? sasUrl?.split("?")[0] : publisher?.logoPath,
                        seoTitle: content.seoTitle,
                        seoDescription: content.seoDescription,
                    }})
                    toast({
                        position: "top-right",
                        title: "Generated Store Logo, About Us, SEO Title, and Description with AI",
                        status: "success",
                        duration: 2000,
                        isClosable: true,
                    });
                    
                } else {
                    setLoading({isLoading: false, loadingMessage: ""})
                    setIsImageLoading(false)
                    toast({
                        position: "top-right",
                        title: "AI server is busy. Please try again.",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                    });
                }
            },
            onError: (err) => {
                setLoading({isLoading: false, loadingMessage: ""})
                setIsImageLoading(false)
                toast({
                    position: "top-right",
                    title: "There was an error while generating AI content. Please try again.",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            },
        }
    );

    const onChange = (e, type) => {
        if ( e?.target?.name === "seoTitle" || e?.target?.name === "seoDescription" || e?.target?.name === "instagram" || e?.target?.name === "facebook" || e?.target?.name === "linkedin" || e?.target?.name === "x" || e?.target?.name === "logo") {
            setBuildStore(true)
        }
        if (type === "about") {
            updateStates({ storeSetting: {
                ...storeSetting,
                [type]: e,
            }})
        } else {
            updateStates({ storeSetting: {
                ...storeSetting,
                [e.target.name]: e.target.value,
            }})
        }
    };

    const onCancelImageModal = () => {
        setImageUrl(publisher.logoPath)
        onClose()
    }

    const onCancelVideoModal = () => {
        setVideoUrl(publisher.videoPath)
        videoOnClose()
    }

    const onCancelPPTModal = () => {
        setPptUrl(pptTheme)
        pptOnClose()
    }

    const updateStoreSetting = async (e) => {
        e.preventDefault();
        setLoading({isLoading: true, loadingMessage: "Updating store settings..."})
        let isStoreSettingComplete = false
        if (storeSetting?.about && storeSetting?.logoPath && storeSetting?.videoPath) {
            isStoreSettingComplete = true
        }
        if( (storeSetting.seoTitle !== publisher.seoTitle) || (storeSetting.seoDescription !== publisher.seoDescription) || (storeSetting.instagram !== publisher.instagram) || (storeSetting.facebook !== publisher.facebook) || (storeSetting.linkedin !== publisher.linkedin) || (storeSetting.x !== publisher.x) || (storeSetting.logoPath !== publisher.logoPath)) {
            setBuildStore(true)
        }
        updatePublisher({
            variables: {
                where: {
                    id: publisher.id,
                },
                data: {
                    publisherName: { set: storeSetting.publisherName },
                    about: { set: storeSetting.about },
                    logoPath: { set: imageUrl },
                    videoPath: { set: videoUrl },
                    ...(storeSetting.instagram ? { instagram: { set: storeSetting.instagram } } : null),
                    ...(storeSetting.facebook ? { facebook: { set: storeSetting.facebook } } : null),
                    ...(storeSetting.linkedin ? { linkedin: { set: storeSetting.linkedin } } : null),
                    ...(storeSetting.x ? { x: { set: storeSetting.x } } : null),
                    ...(storeSetting.seoTitle ? { seoTitle: { set: storeSetting.seoTitle } } : null),
                    ...(storeSetting.seoDescription ? { seoDescription: { set: storeSetting.seoDescription } } : null),
                    ...(storeSetting.additionalLink ? { additionalLink: { set: pptTheme } } : null),
                    otherInfo: {
                        ...storeSetting.otherInfo,
                        isStoreSettingComplete: isStoreSettingComplete
                    }
                },
            },
        });
    };

    const checkWebsite = async (url) => {
        try {
            const response = await fetch(url, { method: 'HEAD' });
            if (response.ok) {
                console.log("Build Done")
                updatePublisher({
                    variables: {
                        where: {
                            id: publisher.id,
                        },
                        data: {
                            otherInfo: {
                                ...storeSetting.otherInfo,
                                isBuildComplete: true
                            }
                        },
                    },
                });
            } else {
                return
            }
        } catch (error) {
            return error
        }
    };

    const createStoreAbout = () => {
        setLoading(true)
        setLoading({isLoading: true, loadingMessage: "Our AI assistant is cooking up your logo, About Us, and SEO magic… ✨"})
        setIsImageLoading(true)
        createAboutAndSeo({
            variables: {
                where: {
                    id: publisher?.id
                },
                data: {
                    userMessage: prompt
                }
            }
        })
    }

    const onConfirmPptTheme = () => {
        setPptTheme(pptUrl)
        pptOnClose()
    }

    const resetPptTheme = () => {
        setPptUrl("")
        setPptTheme(defaultPPTTheme)
    }

    useEffect(() => {
        if (publisher?.id && storeSetting?.id) {
            setVideoUrl(storeSetting.videoPath)
            setImageUrl(storeSetting.logoPath)
            setPptUrl(storeSetting.additionalLink)
            setPptTheme(storeSetting.additionalLink)
        }
        if (publisher?.id && !storeSetting?.id) {
            updateStates({ storeSetting: publisher });
            setVideoUrl(publisher.videoPath)
            setImageUrl(publisher.logoPath)
            setPptUrl(publisher.additionalLink)
            setPptTheme(publisher.additionalLink)
        }
    }, [publisher, updateStates, storeSetting]);

    useEffect(() => {
        return () => {
            toast.closeAll()
        }
    }, [toast])

    return {
        storeSetting,
        updateStoreSetting,
        isOpen,
        onOpen,
        onClose,
        onChange,
        imageUrl,
        videoUrl,
        selectMedia,
        loading,
        videoOnOpen,
        videoIsOpen,
        videoOnClose,
        onCancelImageModal,
        onCancelVideoModal,
        user,
        building,
        prompt,
        isImageLoading,
        setIsImageLoading,
        setPrompt,
        createStoreAbout,
        pptOnOpen,
        pptIsOpen,
        pptUrl,
        onCancelPPTModal,
        resetPptTheme,
        onConfirmPptTheme,
        pptTheme
    }
}
